module.exports = __webpack_public_path__ + "static/PiP_research_summary-fee3e952d1c2ab23630e06229784fe95.pdf";